/** userData 的各个应用所对应的 key */
export const userDataAppid = {
  /** 计算笔记本应用的 key */
  NodeCalc: 'noteCalc',
  /** useApiStorage 的 key */
  storage_api: 'storage_api',
  /**  用于存储分享信息 */
  shareInfo: 'shareInfo',
};
